import BaseRepository from "@/services/resources/repository";
import translatable from "@/services/resources/mixins/translatable-record";
import Context from "@/services/context";


class Repository extends BaseRepository {
    static #fetchPromises = {};

    static make(model, schema) {
        return new Repository(model, schema).$mix(translatable);
    }

    collection() {
        if (Repository.#fetchPromises[Context.getLanguage()]) {
            return Repository.#fetchPromises[Context.getLanguage()];
        }

        Repository.#fetchPromises[Context.getLanguage()] = this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('translated')
                    .include('cookie-items')
                    .sort('sort', 'asc')
                    .get()
            )
        );

        return Repository.#fetchPromises[Context.getLanguage()];
    }

    getCookieList(){
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .sort('sort', 'asc')
                    .get()
            )
        );
    }

}

export default Repository;
